/**
 * @generated SignedSource<<2cfb5bf7039dded6dfed8aa80bdaee45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarAuctionItemsLazy_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItems_item">;
  readonly " $fragmentType": "PdpRespSimilarAuctionItemsLazy_item";
};
export type PdpRespSimilarAuctionItemsLazy_item$key = {
  readonly " $data"?: PdpRespSimilarAuctionItemsLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItemsLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarAuctionItemsLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItems_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b7713c4a36154258d003e5be38ce1470";

export default node;
